import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-893184e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "root-box"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "c_999999" }, "加载中...", -1))

import { ref, onMounted } from 'vue'

import { Loading } from 'vant'

export default /*#__PURE__*/_defineComponent({
  __name: 'MyLoading',
  setup(__props, { expose: __expose }) {

let show = ref(false)

const showLoading = () => {
  show.value = true
}
const hideLoading = (callback: any) => {
  show.value = false
  callback && setTimeout(() => callback(), 500)
}

__expose({
  show,
  showLoading,
  hideLoading
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "animate__animated animate__fadeIn",
    "leave-active-class": "animate__animated animate__fadeOut"
  }, {
    default: _withCtx(() => [
      (_unref(show))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Loading), {
              size: "24px",
              vertical: "",
              color: "#999"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})